import React from 'react'
import GetIcon from '../../../../../utils/Icon'

function Tab4() {
    return (
        <div
            className="row  m-0"
            style={{ padding: "8px", borderRadius: "5px" }}
        >
            <div className="col-12">

                <div className="tableLabel">
                    <div>
                        <div>
                            <p className="mb-1" style={{ color: "#1E1E1E", fontWeight: '500', fontSize: "16x" }}>
                                Fulfillment
                            </p>
                        </div>

                        <div className="mt-2 d-flex gap-4 ">

                            <div className="d-flex align-items-center gap-3 ">
                                <div className="invoice-button">
                                    <span className="invoice-icon">
                                        <GetIcon iconName="FaPlus" size={10} className='mb-1' />
                                    </span>
                                    <span className="invoice-label mt-1">Create Sales Invoice</span>
                                </div>

                                <div className="invoice-count">
                                    3
                                </div>
                            </div>
                            <div className="d-flex align-items-center gap-3 ">
                                <div className="invoice-button">
                                    <span className="invoice-icon">
                                        <GetIcon iconName="FaPlus" size={10} />
                                    </span>
                                    <span className="invoice-label mt-1">Create Pick List</span>
                                </div>

                                <div className="invoice-count">
                                    6
                                </div>
                            </div>
                            <div className="d-flex align-items-center gap-3">
                                <div className="invoice-button">
                                    <span className="invoice-icon">
                                        <GetIcon iconName="FaPlus" size={10} />
                                    </span>
                                    <span className="invoice-label mt-1">Create Pick List</span>
                                </div>

                                <div className="invoice-count">
                                    5
                                </div>
                            </div>

                            <div className="d-flex align-items-center gap-3 ">
                                <div className="invoice-button">
                                    <span className="invoice-icon">
                                        <GetIcon iconName="FaPlus" size={10} />
                                    </span>
                                    <span className="invoice-label mt-1">Create Delivery Note</span>
                                </div>

                                <div className="invoice-count">
                                    2
                                </div>
                            </div>
                            <div className="d-flex align-items-center gap-3 ">
                                <div className="invoice-button">
                                    <span className="invoice-icon">
                                        <GetIcon iconName="FaPlus" size={10} />
                                    </span>
                                    <span className="invoice-label mt-1">Create Maintenance Visit</span>
                                </div>

                                <div className="invoice-count">
                                    3
                                </div>
                            </div>
                        </div>
                        <div className='mt-4 d-flex ' style={{ gap: '90px' }} >
                            <div className='part-1'>
                                <div>
                                    <p className="mb-1" style={{ color: "#1E1E1E", fontWeight: '500', fontSize: "14px" }}>
                                        Purchasing
                                    </p>
                                </div>

                                <div className="mt-2 d-flex gap-4 ">

                                    <div className="d-flex align-items-center gap-3 ">
                                        <div className="invoice-button">
                                            <span className="invoice-icon">
                                                <GetIcon iconName="FaPlus" size={10} />
                                            </span>
                                            <span className="invoice-label mt-1">Create Material Request</span>
                                        </div>

                                        <div className="invoice-count">
                                            3
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center gap-3 ">
                                        <div className="invoice-button">
                                            <span className="invoice-icon">
                                                <GetIcon iconName="FaPlus" size={10} />
                                            </span>
                                            <span className="invoice-label mt-1">Create Purchase Order</span>
                                        </div>

                                        <div className="invoice-count">
                                            6
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="invoice-button">
                                            <span className="invoice-icon">
                                                <GetIcon iconName="FaPlus" size={10} />
                                            </span>
                                            <span className="invoice-label mt-1">Add Auto Repeat</span>
                                        </div>

                                        <div className="invoice-count">
                                            5
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className='part-2'>
                                <div>
                                    <p className="mb-1" style={{ color: "#1E1E1E", fontWeight: '500', fontSize: "14px" }}>
                                        Projects
                                    </p>
                                </div>

                                <div className="mt-2 d-flex gap-5 ">

                                    <div className="d-flex align-items-center gap-3 ">
                                        <div className="invoice-button">
                                            <span className="invoice-icon">
                                                <GetIcon iconName="FaPlus" size={10} />
                                            </span>
                                            <span className="invoice-label mt-1">Create Project</span>
                                        </div>

                                        <div className="invoice-count">
                                            3
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                        <div className='mt-4 d-flex ' style={{ gap: '108px' }} >
                            <div className='part-1'>
                                <div>
                                    <p className="mb-1" style={{ color: "#1E1E1E", fontWeight: '500', fontSize: "14px" }}>
                                        Reference
                                    </p>
                                </div>

                                <div className="mt-2 d-flex gap-4 ">

                                    <div className="d-flex align-items-center gap-3 ">
                                        <div className="invoice-button">
                                            <span className="invoice-icon">
                                                <GetIcon iconName="FaPlus" size={10} />
                                            </span>
                                            <span className="invoice-label mt-1">Create Quotation</span>
                                        </div>

                                        <div className="invoice-count">
                                            3
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center gap-3 ">
                                        <div className="invoice-button">
                                            <span className="invoice-icon">
                                                <GetIcon iconName="FaPlus" size={10} />
                                            </span>
                                            <span className="invoice-label mt-1">Create Auto Repeat</span>
                                        </div>

                                        <div className="invoice-count">
                                            6
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="invoice-button">
                                            <span className="invoice-icon">
                                                <GetIcon iconName="FaPlus" size={10} />
                                            </span>
                                            <span className="invoice-label mt-1">Stock Reservation Entry</span>
                                        </div>

                                        <div className="invoice-count">
                                            5
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className='part-2'>
                                <div>
                                    <p className="mb-1" style={{ color: "#1E1E1E", fontWeight: '500', fontSize: "14px" }}>
                                        Manufacturing
                                    </p>
                                </div>

                                <div className="mt-2 d-flex gap-4 ">

                                    <div className="d-flex align-items-center gap-3 ">
                                        <div className="invoice-button">
                                            <span className="invoice-icon">
                                                <GetIcon iconName="FaPlus" size={10} />
                                            </span>
                                            <span className="invoice-label mt-1">Create Work Order</span>
                                        </div>

                                        <div className="invoice-count">
                                            3
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                        <div>
                            <div className='mt-4 d-flex mb-5 ' style={{ gap: '90px' }} >
                                <div className='part-1'>
                                    <div>
                                        <p className="mb-1" style={{ color: "#1E1E1E", fontWeight: '500', fontSize: "14px" }}>
                                            Payment
                                        </p>
                                    </div>

                                    <div className="mt-2 d-flex gap-4 ">

                                        <div className="d-flex align-items-center gap-3 ">
                                            <div className="invoice-button">
                                                <span className="invoice-icon">
                                                    <GetIcon iconName="FaPlus" size={10} />
                                                </span>
                                                <span className="invoice-label mt-1">Create Payment Entry</span>
                                            </div>

                                            <div className="invoice-count">
                                                3
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center gap-3 ">
                                            <div className="invoice-button">
                                                <span className="invoice-icon">
                                                    <GetIcon iconName="FaPlus" size={10} />
                                                </span>
                                                <span className="invoice-label mt-1">Payment Request</span>
                                            </div>

                                            <div className="invoice-count">
                                                6
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center gap-3">
                                            <div className="invoice-button">
                                                <span className="invoice-icon">
                                                    <GetIcon iconName="FaPlus" size={10} />
                                                </span>
                                                <span className="invoice-label mt-1">Create Journal Entry</span>
                                            </div>

                                            <div className="invoice-count">
                                                5
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>


                </div>

            </div>

        </div>
    )
}

export default Tab4
